"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rdf_string_1 = require("rdf-string");

var sparqlalgebrajs_1 = require("sparqlalgebrajs");

var sparqlee_1 = require("sparqlee");

var bus_query_operation_1 = require("@comunica/bus-query-operation");

var SortIterator_1 = require("./SortIterator");
/**
 * A comunica OrderBy Sparqlee Query Operation Actor.
 */


var ActorQueryOperationOrderBySparqlee =
/*#__PURE__*/
function (_bus_query_operation_) {
  _inherits(ActorQueryOperationOrderBySparqlee, _bus_query_operation_);

  function ActorQueryOperationOrderBySparqlee(args) {
    var _this;

    _classCallCheck(this, ActorQueryOperationOrderBySparqlee);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ActorQueryOperationOrderBySparqlee).call(this, args, 'orderby'));
    _this.window = args.window || Infinity;
    return _this;
  }

  _createClass(ActorQueryOperationOrderBySparqlee, [{
    key: "testOperation",
    value: function () {
      var _testOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(pattern, context) {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, expr, _;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Will throw error for unsupported operators
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 3;

                for (_iterator = pattern.expressions[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  expr = _step.value;
                  expr = this.extractSortExpression(expr);
                  _ = new sparqlee_1.AsyncEvaluator(expr);
                }

                _context.next = 11;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](3);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 11:
                _context.prev = 11;
                _context.prev = 12;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 14:
                _context.prev = 14;

                if (!_didIteratorError) {
                  _context.next = 17;
                  break;
                }

                throw _iteratorError;

              case 17:
                return _context.finish(14);

              case 18:
                return _context.finish(11);

              case 19:
                return _context.abrupt("return", true);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 7, 11, 19], [12,, 14, 18]]);
      }));

      function testOperation(_x, _x2) {
        return _testOperation.apply(this, arguments);
      }

      return testOperation;
    }()
  }, {
    key: "runOperation",
    value: function () {
      var _runOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(pattern, context) {
        var _this2 = this;

        var outputRaw, output, options, sparqleeConfig, bindingsStream, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _loop, _iterator2, _step2;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.mediatorQueryOperation.mediate({
                  operation: pattern.input,
                  context: context
                });

              case 2:
                outputRaw = _context3.sent;
                output = bus_query_operation_1.ActorQueryOperation.getSafeBindings(outputRaw);
                options = {
                  window: this.window
                };
                sparqleeConfig = Object.assign({}, bus_query_operation_1.ActorQueryOperation.getExpressionContext(context));
                bindingsStream = output.bindingsStream;
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context3.prev = 10;

                _loop = function _loop() {
                  var expr = _step2.value;

                  var isAscending = _this2.isAscending(expr);

                  expr = _this2.extractSortExpression(expr); // Transform the stream by annotating it with the expr result

                  var evaluator = new sparqlee_1.AsyncEvaluator(expr, sparqleeConfig);

                  var transform =
                  /*#__PURE__*/
                  function () {
                    var _ref = _asyncToGenerator(
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee2(bindings, next) {
                      var result;
                      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              _context2.prev = 0;
                              _context2.next = 3;
                              return evaluator.evaluate(bindings);

                            case 3:
                              result = _context2.sent;

                              transformedStream._push({
                                bindings: bindings,
                                result: result
                              });

                              _context2.next = 11;
                              break;

                            case 7:
                              _context2.prev = 7;
                              _context2.t0 = _context2["catch"](0);

                              if (!sparqlee_1.isExpressionError(_context2.t0)) {
                                bindingsStream.emit('error', _context2.t0);
                              }

                              transformedStream._push({
                                bindings: bindings,
                                result: undefined
                              });

                            case 11:
                              next();

                            case 12:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      }, _callee2, null, [[0, 7]]);
                    }));

                    return function transform(_x5, _x6) {
                      return _ref.apply(this, arguments);
                    };
                  }();

                  var transformedStream = bindingsStream.transform({
                    transform: transform
                  }); // Sort the annoted stream

                  var sortedStream = new SortIterator_1.SortIterator(transformedStream, function (a, b) {
                    var orderA = rdf_string_1.termToString(a.result);
                    var orderB = rdf_string_1.termToString(b.result);

                    if (!orderA || !orderB) {
                      return 0;
                    }

                    return orderA > orderB === isAscending ? 1 : -1;
                  }, options); // Remove the annotation

                  bindingsStream = sortedStream.map(function (_ref2) {
                    var bindings = _ref2.bindings,
                        result = _ref2.result;
                    return bindings;
                  });
                };

                for (_iterator2 = pattern.expressions[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  _loop();
                }

                _context3.next = 19;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3["catch"](10);
                _didIteratorError2 = true;
                _iteratorError2 = _context3.t0;

              case 19:
                _context3.prev = 19;
                _context3.prev = 20;

                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                  _iterator2.return();
                }

              case 22:
                _context3.prev = 22;

                if (!_didIteratorError2) {
                  _context3.next = 25;
                  break;
                }

                throw _iteratorError2;

              case 25:
                return _context3.finish(22);

              case 26:
                return _context3.finish(19);

              case 27:
                return _context3.abrupt("return", {
                  type: 'bindings',
                  bindingsStream: bindingsStream,
                  metadata: output.metadata,
                  variables: output.variables
                });

              case 28:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[10, 15, 19, 27], [20,, 22, 26]]);
      }));

      function runOperation(_x3, _x4) {
        return _runOperation.apply(this, arguments);
      }

      return runOperation;
    }() // Remove descending operator if necessary

  }, {
    key: "extractSortExpression",
    value: function extractSortExpression(expr) {
      var expressionType = expr.expressionType,
          operator = expr.operator;

      if (expressionType !== sparqlalgebrajs_1.Algebra.expressionTypes.OPERATOR) {
        return expr;
      }

      return operator === 'desc' ? expr.args[0] : expr;
    }
  }, {
    key: "isAscending",
    value: function isAscending(expr) {
      var expressionType = expr.expressionType,
          operator = expr.operator;

      if (expressionType !== sparqlalgebrajs_1.Algebra.expressionTypes.OPERATOR) {
        return true;
      }

      return operator !== 'desc';
    }
  }]);

  return ActorQueryOperationOrderBySparqlee;
}(bus_query_operation_1.ActorQueryOperationTypedMediated);

exports.ActorQueryOperationOrderBySparqlee = ActorQueryOperationOrderBySparqlee;